import { Dialog } from "primereact/dialog";
import Usuario from "../../model/Usuario";
import { Button } from "primereact/button";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { cnpjMask, cpfMask } from "../../utils/mask";
import CPF from 'cpf-check';
import { validate } from "cnpj";
import UsuarioService from "../../service/administracao/UsuarioService";
import { useToastContext } from "../../provider/ToastContext";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
}

const usuarioService = new UsuarioService();
export default function InserirUsuarioDialog({ visible, onHide, onConfirm }: Props) {

    const { msgErro } = useToastContext();
    const [tipo, setTipo] = useState<'CPF' | 'CNPJ'>('CPF');
    const [documento, setDocumento] = useState<string>('');

    const handleConfirm = () => {
        if (!validar()) return
        if (tipo === 'CPF') {
            usuarioService.inserirPeloCpf(documento.replace(/\D/g, '')).then(() => {
                onConfirm();
            }).catch((error) => {
                msgErro('Erro ao inserir usuário por CPF.', error?.data?.message || 'Verifique se o CPF está correto e tente novamente.');
            });
        } else {
            usuarioService.inserirPeloCnpj(documento.replace(/\D/g, '')).then(() => {
                onConfirm();
            }).catch((error) => {
                msgErro('Erro ao inserir usuário por CNPJ.', error?.data?.message || 'Verifique se o CNPJ está correto e tente novamente.');
            });
        }
    }

    const validar = () => {
        if (tipo === 'CPF') {
            const cpfLimpo = documento.replace(/\D/g, '');
            return CPF.validate(cpfLimpo);
        } else {
            const cnpjLimpo = documento.replace(/\D/g, '');
            return validate(cnpjLimpo);
        }
    }

    return (
        <Dialog
            header="Confirmar Reset de Senha"
            visible={visible}
            style={{ width: "450px" }}
            onHide={() => onHide()}
            footer={
                <div>
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        outlined
                        className="p-button-text"
                        onClick={() => onHide()}
                    />
                    <Button
                        label="Inserir"
                        icon="pi pi-plus"
                        onClick={handleConfirm}
                    />
                </div>
            }
        >
            <label>Tipo do documento</label>
            <Dropdown
                value={tipo}
                options={[{ label: 'CPF', value: 'CPF' }, { label: 'CNPJ', value: 'CNPJ' }]}
                onChange={(e) => {
                    setTipo(e.value);
                    setDocumento('');
                }}
                className="w-full mb-3"
            />

            <label>{tipo}</label>
            <div>
                {tipo === 'CPF' ? (
                    <InputText value={documento}
                        style={documento ?
                            cpfMask(documento).length == 14 ?
                                CPF.validate(documento) || documento == '000.000.000-00' ?
                                    { color: "#22211e", width: '100%' } :
                                    { color: "red", width: '100%' } :
                                { width: '100%' } :
                            { color: "red", width: '100%' }
                        }
                        onChange={(e) => {
                            setDocumento(cpfMask(e.target.value));
                        }}

                    />
                ) : (
                    <InputText value={documento}
                        style={documento ?
                            cnpjMask(documento).length == 18 ?
                                validate(cnpjMask(documento)) || documento == '00.000.000/0000-00' ?
                                    { color: "#22211e", width: '100%' } :
                                    { color: "red", width: '100%' } :
                                { width: '100%' } :
                            { width: '100%' }}
                        onChange={(e) => {
                            setDocumento(cnpjMask(e.target.value));
                        }}

                    />
                )}
            </div>
        </Dialog>
    )
}